import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { InvoiceListCreatedAtCell } from './invoice-list-created-at.cell';
import { InvoiceListCreatedAtHeader } from './invoice-list-created-at.header';

export const InvoiceListCreatedAtColumn: IdentifiedColumnDef<
  InvoiceModel,
  InvoiceModel['createdAt']
> = {
  enableSorting: true,
  header: InvoiceListCreatedAtHeader,
  cell: InvoiceListCreatedAtCell,
  meta: { maxWidth: '165px', width: '160px' },
};
